import type { ChatClient, StreamingChatClient } from './types'
import { MockChatClient } from './MockChatClient'
import { MockStreamingChatClient } from './MockStreamingChatClient'
import { SseStreamingChatClient } from './SseStreamingChatClient'
import { createChatClient } from './botApi'
import { getConfig } from '@/config'

export * from './types'
export * from './fileService'
export * from './botApi'
export * from './http'
export * from './sampleQuestionsCard'

export const chatClient: ChatClient = createChatClient()

/** Keep mock client available for local development / Storybook / tests. */
export const mockChatClient: ChatClient = new MockChatClient()
export const mockStreamingClient: StreamingChatClient = new MockStreamingChatClient()

let _sseStreamingClient: StreamingChatClient | null = null
export function getSseStreamingClient(): StreamingChatClient {
  if (!_sseStreamingClient) {
    _sseStreamingClient = new SseStreamingChatClient(getConfig().apiBaseUrl)
  }
  return _sseStreamingClient
}

// Default export for backwards compatibility
export const streamingClient = mockStreamingClient
